import { webPortalApi } from '#config/web-portal-api';
import { SearchDeviceOption } from '#service/autocomplete-service/option';
import { getRequestOptions } from '#helper';

class SearchDeviceOptionService {
  #searchFields;

  constructor(searchFields) {
    if (!searchFields?.length) {
      throw new Error('Search fields are not provided');
    }

    this.#searchFields = searchFields;
  }

  async fetchOptionsRaw(value, fetchOptions = {}, params = {}) {
    const searchParams = new URLSearchParams({
      limit: 50,
      order: 'asc',
      orderBy: 'title',
      offset: 0,
      pagination: 1,
      withoutYoungest: 1
    });
    const { excludeIds, excludeProjects } = params;

    if (value) {
      searchParams.set('filter', value);
      searchParams.set('filterBy', this.#searchFields);
    }

    if (excludeIds) {
      searchParams.set('excludeIds', excludeIds);
    }

    if (excludeProjects) {
      searchParams.set('excludeProjects', excludeProjects);
    }

    const devicesURL = webPortalApi.buildApiUrl(`device/distinct/details?${searchParams.toString()}`);
    const res = await fetch(devicesURL, { ...getRequestOptions(), ...fetchOptions });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }

    const r = res.json();

    if (!res.ok) {
      throw await r;
    }

    return r;
  }

  async getOptions(value, fetchOptions, params) {
    const fetchedOptions = await this.fetchOptionsRaw(value, fetchOptions, params);
    const transformedOptions = this.transformOptions(fetchedOptions);

    return transformedOptions;
  }

  transformOptions(options) {
    return options?.devices?.map(option => {
      const label = `${option.title}`;
      return new SearchDeviceOption(option, label);
    });
  }
}

export default SearchDeviceOptionService;
